import { selectTeamById } from "@overmap-ai/core"
import { createFileRoute, notFound, Outlet } from "@tanstack/react-router"
import { appStore } from "src/store"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/settings/teams/$teamId")({
	component: Outlet,
	loader: ({ params }) => {
		const team = selectTeamById(params.teamId)(appStore.getState())
		if (!team) throw notFound()
		return team
	},
})
